export const services = [
  {
    id: "b2b-contact-insights",
    title: "B2B Contact Insights",
    description: "Direct-dial and verified work email access for decision-makers across global enterprise and mid-market accounts.",
    icon: "Users",
    link: "/services/b2b-contact-insights",
  },
  {
    id: "b2b-company-data",
    title: "B2B Company Data",
    description: "Firmographic telemetry, technographics, employee headcount trends, and revenue indicators for account-based targeting.",
    icon: "Building2",
    link: "/services/b2b-company-data",
  },
  {
    id: "data-appending",
    title: "Data Appending",
    description: "Fill missing fields, update decayed phone numbers, and append verified social profiles directly to your CRM records.",
    icon: "FileSpreadsheet",
    link: "/services/data-appending",
  },
  {
    id: "data-validation",
    title: "Data Validation",
    description: "Multi-point hygiene checks eliminating syntax anomalies, invalid domain entries, and dormant records before outbound campaigns.",
    icon: "CheckCircle2",
    link: "/services/data-validation",
  },
  {
    id: "data-verification",
    title: "Data Verification",
    description: "Real-time SMTP handshake and human-in-the-loop verification providing 95%+ email deliverability guarantees.",
    icon: "ShieldCheck",
    link: "/services/data-verification",
  },
  {
    id: "b2b-appointment",
    title: "B2B Appointment Setting",
    description: "Qualified sales meetings scheduled directly on your team's calendar with pre-vetted corporate buying committees.",
    icon: "CalendarCheck",
    link: "/services/b2b-appointment",
  },
 
];